import styled from "styled-components";
import theme from "theme";
import { CheckboxSizes } from "theme/checkbox/types";
import { colors } from "../../theme/colors";
import { CheckboxProps } from "./types";

const getCheckboxSize = ({ size }: { size?: CheckboxSizes }) =>
    theme.checkbox.sizes[size || "S"];

export const StyledCheckbox = styled("span")`
    border-radius: 3px;
    background-color: #eee;
    width: 100%;
    height: 100%;
    transition: all 100ms ease-out;
    ${theme.mixins.flexCenter};
    svg {
        display: none;
        width: 60%;
        height: 60%;
    }
`;

export const StyledCheckboxWrapper = styled("div")<{
    size: CheckboxSizes;
}>`
    display: flex;
    position: relative;
    width: ${getCheckboxSize};
    height: ${getCheckboxSize};
`;

export const HiddenCheckbox = styled("input")<CheckboxProps>`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    border: 6px solid ${colors.grey.tertiary2};
    &:checked ~ ${StyledCheckbox} {
        label {
            color: ${colors.purple.primary};
        }
        svg {
            display: block;
        }
        background-color: ${colors.purple.primary};
    }
`;

export const Container = styled("label")<{
    fullWidth?: boolean;
}>`
    ${theme.mixins.flexCenter};
    justify-content: unset;
    gap: 0.5rem;
    cursor: pointer;
    width: ${({ fullWidth }) => fullWidth && "100%"};
    user-select: none;
`;
